<!-- 应用组件 - 应用中心主页面，展示按分类分组的应用列表，支持路由跳转至子模块 -->

<!-- getAppsList - 获取应用列表数据，请求接口并渲染分类卡片，失败时提示错误信息 -->

<!-- goJump - 点击应用卡片的跳转处理，无权限时跳转应用详情页，有权限时根据应用类型路由至对应子模块（apps_id为1时跳转导购员名单，其余跳转应用详情页） -->
<!-- 应用组件 -->
<template>
    <div class="container">
        <template v-if="$route.path === '/admin/assembly'">
            <div
                v-for="(item, index) in appData"
                :key="index"
                class="content mb24"
            >
                <div class="title-container">
                    <div
                        class="title"
                        :style="`background: ${item.font_color};`"
                    ></div>
                    {{ item.name }}
                </div>
                <div class="flex-wrap mt24 position-relative">
                    <div
                        v-for="(e, i) in item.list"
                        :key="i"
                        class="card"
                        @click="goJump(e)"
                        :style="`background: ${item.bg_color};`"
                    >
                        <img
                            v-if="e.icon"
                            :src="e.show_icon"
                            class="card-icon"
                        />
                        <div class="flex flex-col">
                            <div class="card-title card-txt">{{ e.name }}</div>
                            <div v-if="e.desc" class="card-txt">
                                {{ e.desc }}
                            </div>
                        </div>
                        <div v-if="!e.is_permission" class="card-mask"></div>
                    </div>
                </div>
            </div>
        </template>
        <template>
            <router-view></router-view>
        </template>
    </div>
</template> 

<script>
import { apps_list } from "@/api/index";
export default {
    data() {
        return {
            appData: [],
        };
    },
    mounted() {
        this.getAppsList();
    },
    methods: {
        async getAppsList() {
            try {
                const res = await apps_list();
                this.appData = res.data;
            } catch (err) {
                const errorMsg =
                    err?.msg || err?.message || "加载应用列表失败，请刷新重试";
                this.$Message.error(errorMsg);
            }
        },
        goJump(e) {
            // 测试
            // this.$router.push({ path: "/admin/assembly/order" });
            // return;
            if (!e.is_permission) { 
                this.$router.push({
                    path: "/admin/assembly/info",
                    query: {
                        title: e.name,
                        id: e.id,
                        apps_id: e.apps_id,
                    },
                });
            } else {
                if (e.apps_id == 1) {
                    // 微信关注扫码领红包
                    this.$router.push({ path: "/admin/assembly/wxpacket" });
                    return;
                } else if (e.apps_id == 12) {
                    // 积分商城
                    this.$router.push({ path: "/admin/assembly/mall" });
                    return;
                } else if (e.apps_id == 13) {
                    // 扫码领积分
                    this.$router.push({ path: "/admin/assembly/integral" });
                    return;
                } else if (e.apps_id == 14) {
                    // 导购员名单
                    this.$router.push({ path: "/admin/assembly/list" });
                    return;
                } else if (e.apps_id == 15) {
                    // 大转盘
                    this.$router.push({ path: "/admin/assembly/luckywheel" });
                    return;
                }
                this.$router.push({
                    path: "/admin/assembly/info",
                    query: {
                        title: e.name,
                        id: e.id,
                        apps_id: e.apps_id,
                    },
                });
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px 24px 0 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.card-mask {
    margin-left: -12px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    width: 280px;
    height: 80px;
    background-color: rgb(147 146 146 / 51%);
    z-index: 1000;
    position: absolute;
    cursor: pointer;
}
.card-icon {
    margin-right: 12px;
    width: 50px;
    height: 50px;
}
.card {
    margin: 0 24px 24px 0;
    padding: 12px;
    min-width: 280px;
    width: 280px;
    max-width: 280px;
    height: 80px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #747b95;
    cursor: pointer;
}
.flex {
    display: flex;
}
.card-title {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #484e66;
}
.card-txt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 200px;
    display: inline-block;
}
.flex-col {
    flex-direction: column !important;
}
.position-relative {
    position: relative;
}
.title-container {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
}
.title {
    width: 4px;
    height: 18px;
    border-radius: 5px;
    margin-right: 5px;
}
.flex-wrap {
    display: flex;
    flex-wrap: wrap;
}
</style>